export default {
      id: "sprite-usage",
      viewBox: undefined,
      url: __webpack_public_path__ + "img/icons.c6bd5ddf.svg#sprite",
      toString: function () {
        return this.url;
      }
    }